import $ from 'jquery';

// Fullpage.js
$(function() {
  $('#header').hide();
	$('#fullpage').fullpage({
    anchors:['main','about', 'auto', 'train', 'plane', 'hyperloop', 'ending'],
    css3: true,
    scrollOverflowReset: true,
    onLeave: function(index, nextIndex, direction) {

		if(index === 1 && direction ==='down'){
      $("#header").fadeIn('slow');
		}

    var $tesla = $('.tesla'),
    $heading = $('.heading'),
    $subheading = $('.subheading'),
    $train = $('.train__anim'),
    $plane = $('.plane-img'),
    $hyperloop = $('.hyperloop-img');
    if ( index === 2 && direction === 'down') {
        $tesla.toggleClass('animated fadeInRight');
    }
    if (index === 3 && direction === 'down') {
        $train.toggleClass('animated fadeInLeft');
    }
    if (index === 4 && direction === 'down') {
        $plane.toggleClass('animated fadeInRight');
    }
    if (index === 5 && direction === 'down') {
        $hyperloop.toggleClass('animated fadeInRight');
    }

  if (direction === 'down' || 'up' && index === true) {
    $heading.toggleClass('animated pulse');
    $subheading.toggleClass('animated pulse')
  }

		if(index === 2 && direction === 'up'){
			$("#header").fadeOut('slow');
		}
	}
});


})



// WEBPACK FOOTER //
// ./src/jslib/fp-functions.js